module.exports = __webpack_public_path__ + "img/background-icons-2.77c26a73.png";